import { ErrorBaseData } from '.'

export const cityErrors: Record<string, ErrorBaseData> = {
  CityNotFoundException: {
    message: 'Cidade não encontrada',
    description: 'Não foi possível encontrar a cidade. Verifique as informações e tente novamente',
  },
}
